import LegalDocumentPage from "@/components/LegalDocumentPage";

export default function PrivacyPage() {
  return <LegalDocumentPage docType="privacy" testId="privacy-page" />;
}
